import React from 'react';
import { GoogleLogin } from '@react-oauth/google';

const LoginScreen = ({ onLoginSuccess }) => {
  return (
    <div style={{ padding: '2rem', textAlign: 'center', width: '350px', margin: '0 auto' }}>
      <h2>Please log in to access the chat</h2>
      <GoogleLogin
        onSuccess={onLoginSuccess}
        onError={() => console.log('Login Failed')}
      />
    </div>
  );
};

export default LoginScreen;